import { render, staticRenderFns } from "./XCPCHonor.vue?vue&type=template&id=7f98eb0e&scoped=true"
import script from "./XCPCHonor.vue?vue&type=script&lang=js"
export * from "./XCPCHonor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f98eb0e",
  null
  
)

export default component.exports